<template>
    <div class="card" id="Clinician__Patients">
        <header class="d-flex align-items-center py-2 px-3 bg-primary text-white font-size-md fw-bold">
            <span> Patients </span>
            <i class="ms-2 fas fa-question-circle" v-tooltip="{ title: tooltip, placement: 'right' }"></i>
            <i class="ms-auto fas fa-times" @click="closePatients()"></i>
        </header>
        <form @submit.prevent="getData">
            <div class="d-flex p-2">
                <input
                    type="text"
                    autofocus
                    class="form-control"
                    v-model="searchQuery"
                    placeholder="Search by Patient Name"
                />
                <div class="input-group-append ms-2">
                    <button type="submit" :disabled="disableForm" class="btn btn-primary">Search</button>
                </div>
            </div>
        </form>
        <ScrollPagination
            class="content-y h-100"
            :page-number="pageNumber"
            :all-pages-loaded="allPagesLoaded"
            :is-loading="isLoading"
            :has-error="hasError"
            v-on:pageNumberUpdate="pageNumberUpdated"
        >
            <section
                class="d-flex flex-column overflow-auto flex-nowrap w-100 h-100 scroll-paginate"
                :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
            >
                <div
                    v-if="patientsList.length && !isLoading && !hasError"
                    class="employee-card"
                    v-for="patient in patientsList"
                    :key="patient.Id"
                >
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <span class="d-flex align-items-center font-size-md">
                            <b>{{ patient.patientFullName }}</b>
                            <i
                                class="ms-1 fas fa-gift text-app-primary"
                                v-tooltip="{ title: patient.birthDateTooltip, trigger: `manual`, hideWait: 2000 }"
                                v-if="patient.isBirthDate"
                            ></i>
                        </span>
                        <a
                            v-if="!patient.IsAxxessCARE"
                            class="align-self-start"
                            href="javascript:void(0);"
                            @click="viewPatient(patient)"
                        >
                            View Chart
                        </a>
                    </div>
                    <div class="d-flex">
                        <ProductPill
                            class="application-name"
                            :product-id="getApplicationId(patient.Application)"
                        ></ProductPill>
                    </div>
                    <div class="text-default pt-1">{{ patient.AgencyName }}</div>
                    <div class="d-flex pt-1">
                        <span class="d-flex align-items-center me-4" v-if="patient.PhoneNumber">
                            <i class="fas fa-mobile text-primary me-1"></i>
                            <a :href="'tel:' + patient.PhoneNumber"> {{ formatPhone(patient.PhoneNumber) }} </a>
                        </span>
                        <span class="d-flex align-items-center" v-if="patient.Dob">
                            <i class="fas fa-birthday-cake text-primary me-1"></i>
                            <span> {{ formatDate(patient.Dob, "MMM DD, YYYY") }} </span>
                        </span>
                    </div>
                </div>
                <!-- WAITING -->
                <p
                    v-if="isLoading && !hasError"
                    class="d-flex flex-column w-100 align-items-center text-center py-5 px-3 text-primary"
                >
                    <i class="fas fa-cogs fa-5x mb-4"></i>
                    <span class="font-size-lg">
                        We are fetching your current patient list.<br />
                        We will have your patient list ready in a moment.
                    </span>
                </p>
                <!-- ERROR -->
                <div v-if="hasError && !isLoading" class="error-state">
                    <p>There was a problem while fetching your patients.<br />Please try again.</p>
                    <button class="btn btn-primary" @click="getData()">Try Again</button>
                </div>
                <!-- NO DATA -->
                <p class="no-data" v-if="patientsList.length === 0 && searchQuery.length">
                    <i> No patient found. </i>
                </p>
                <p class="no-data" v-else-if="patientsList.length === 0 && !isLoading && !hasError">
                    <i>You have not worked with any patients yet.</i>
                </p>
            </section>
        </ScrollPagination>
    </div>
</template>

<script lang="ts" src="./PatientList.ts"></script>
<style lang="scss" src="./PatientList.scss"></style>
